import type { GameItem } from '~/pages/index/types/game-content'

/**
 * 游戏浮层（点击游戏卡片进入的第三方游戏播放页；全局挂载，首页网格/侧栏/搜索等入口共用）
 * 打开时调 POST /games/{id}/enter 取 launch_url / transfer_amount / transfer_currency；点开始游戏直接 iframe 加载，不再请求
 */
export const useGamePlayNav = () => {
  const open = useState('game-play-open', () => false)
  const game = useState<GameItem | null>('game-play-game', () => null)
  // 记录进入来源的回退动作（如从搜索页进入 → 退出后重开搜索页）。
  // 仅客户端交互期间赋值，SSR 阶段恒为 null，不参与序列化
  const back = useState<(() => void) | null>('game-play-back', () => null)

  const openGame = (item: GameItem, onBack?: () => void) => {
    game.value = item
    back.value = onBack ?? null
    open.value = true
  }

  /** 仅关闭浮层，不回退来源（如「订金」跳转钱包时用） */
  const closeGame = () => {
    open.value = false
  }

  /** 退出游戏：关闭浮层并回到进入前的页面（有来源则执行回退） */
  const exitGame = () => {
    open.value = false
    const onBack = back.value
    back.value = null
    if (onBack) onBack()
  }

  return { open, game, openGame, closeGame, exitGame }
}
